import { IconWithBackground } from "../ui/components/IconWithBackground";
import image2 from "../assets/image2.png"

import { FeatherClock, FeatherShield } from "@subframe/core";

const BankGradeCard = () => {
  return (
    <div>
      <div className="flex w-full items-center justify-center gap-6 bg-[#141237ff] px-4 py-16 mobile:px-4 mobile:py-12">
        <div className="flex max-w-[1024px] grow shrink-0 basis-0 flex-wrap items-center justify-center gap-12 mobile:h-auto mobile:grow mobile:shrink-0 mobile:basis-0 mobile:flex-nowrap mobile:gap-8 mobile:flex-col-reverse">
          <div className="flex min-w-[320px] grow shrink-0 basis-0 flex-col items-start gap-6 mobile:h-auto mobile:w-full mobile:flex-none mobile:flex-col mobile:flex-nowrap mobile:items-center mobile:justify-start mobile:gap-4 mobile:text-center">
            <div className="flex flex-col items-start gap-3 mobile:flex-col mobile:flex-nowrap mobile:items-center mobile:justify-start mobile:gap-2">
              <span className="text-white font-semibold text-brand-primary  mobile:text-caption mobile:font-caption">
                Emergency? Bills piling up?
              </span>
              <span className="w-full font-['Afacad_Flux'] text-[40px] font-[600] leading-[48px] text-white -tracking-[0.03em] mobile:font-['Afacad_Flux'] mobile:text-[28px] mobile:font-[400] mobile:leading-[34px] mobile:tracking-normal">
                Get money by midnight
              </span>
              <div className="flex items-center gap-2 rounded-full px-4 py-2 backdrop-blur-sm border border-white mobile:px-3 mobile:py-1.5">
                <IconWithBackground
                  variant="success"
                  size="small"
                  icon={<FeatherShield className="p-1 bg-green-500/90 rounded-full" />}
                />
                <span className="text-white font-body-bold text-success-300 mobile:text-caption-bold mobile:font-caption-bold">
                  Bank-grade security • No hidden fees
                </span>
              </div>
            </div>
            <div className="flex flex-col items-start gap-4 mobile:h-auto mobile:w-full mobile:flex-none mobile:flex-col mobile:flex-nowrap mobile:items-center mobile:justify-start mobile:gap-3">
              <a
                className="px-5 py-2 rounded-full border border-blue-600 text-blue-600 font-medium hover:bg-blue-50 transition-colors"
               href={import.meta.env.VITE_WEBSITE_LINK }
              target="_blank"
              >
                Apply Now
              </a>
              <div className="flex flex-col items-start gap-2 mobile:items-center mobile:justify-start">
                <div className="hidden items-start -space-x-1 > :not([hidden]) ~">
                  <div className="flex h-6 w-6 flex-none items-start rounded-full bg-brand-primary border-2 border-white" />
                  <div className="flex h-6 w-6 flex-none items-start rounded-full bg-success-500 border-2 border-white" />
                  <div className="flex h-6 w-6 flex-none items-start rounded-full bg-warning-500 border-2 border-white" />
                  <div className="flex h-6 w-6 flex-none items-start rounded-full bg-[#3b82f6ff] border-2 border-white" />
                </div>
                <div className="flex items-center gap-2 rounded-md px-3 py-1">
                  <div className="flex h-2 w-2 flex-none items-start rounded-full bg-success-400 @keyframes pulse animate-pulse" />
                  <span className="text-caption -ml-5 font-caption text-neutral-300">
                    ₹1L approved in last hour
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start gap-2">
              <div className="flex items-center gap-2 text-warning-400">
                <IconWithBackground
                  className="hidden"
                  variant="warning"
                  size="small"
                  icon={<FeatherClock />}
                />
                <span className="hidden text-caption font-caption text-default-font">
                  Applications close at midnight
                </span>
              </div>
              <div className="hidden items-center gap-2">
                <span className="text-caption font-caption text-neutral-400">
                  &quot;Got ₹25K in 12 minutes&quot; - Rahul M.
                </span>
              </div>
            </div>
          </div>
          <img
            className="h-112 flex-none object-cover mobile:h-64 mobile:w-full mobile:max-w-[288px] mobile:flex-none mobile:mx-auto"
            src={image2}
          />
        </div>
      </div>
    </div>
  );
};

export default BankGradeCard;
